import { BOAT_RACE_IMAGES, BOAT_RACE_REFERENCE_LINKS_EN } from './boatRacePostUtils';

const GALLERY_IMAGES = {
  heats: BOAT_RACE_IMAGES.heats,
  alleppey: BOAT_RACE_IMAGES.alleppey,
  aranmula: BOAT_RACE_IMAGES.aranmula,
};

/** Thalavady Chundan — history, victories, NTBR & CBL 2026 (English) */
export const THALAVADY_CHUNDAN_ENGLISH_POST = {
  id: 'featured-thalavady-chundan-english',
  slug: 'thalavady-chundan-history-ntbr-cbl-2026',
  title: 'Thalavady Chundan: History, Victories & NTBR / CBL 2026 Preview',
  excerpt:
    'Meet Kerala’s horse-headed snake boat — born in 2023, crowned at Neerattupuram, and rowing into the 72nd Nehru Trophy and Champions Boat League. History, club details, and links to track results.',
  publishedAt: '2026-08-13T18:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.hero,
  authorName: 'Daily Sports Life',
  clubName: 'Kerala Sports Desk',
  blogCategory: 'boat-races',
  locale: 'en',
  boatRaceTopic: 'thalavady-chundan',
  alternateSlug: 'thalavady-chundan-charithram-ntbr-cbl-2026-malayalam',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'Related boat race articles',
  relatedPosts: [
    {
      slug: 'thalavady-chundan-charithram-ntbr-cbl-2026-malayalam',
      title: 'തലവടി ചുണ്ടൻ: ചരിത്രം, വിജയങ്ങൾ, NTBR & CBL 2026 (മലയാളം)',
      blurb: 'Malayalam edition — same story with full local detail.',
    },
    {
      slug: 'nehru-trophy-2026-chundan-snake-boats-captains',
      title: '72nd Nehru Trophy 2026: 22 Chundan Boats, Clubs & Captains',
      blurb: 'Full NTBR 2026 line-up, captain table, and race-day guide.',
    },
    {
      slug: 'kerala-boat-race-nehru-trophy-ntbr-history',
      title: 'Kerala Boat Race Guide: NTBR 2026 & Nehru Trophy History',
      blurb: 'Vallamkali background, visitor tips, and Nehru Trophy timeline.',
    },
  ],
  referenceLinks: [
    {
      label: 'Kerala Tourism — Thalavady Chundan profile',
      url: 'https://www.keralatourism.org/champions-boat-league/snake-boats/thalavady-chundan',
    },
    {
      label: 'Thalavady Chundan on Facebook',
      url: 'https://www.facebook.com/thalavadychundan/',
    },
    {
      label: 'Thalavady Chundan on Instagram',
      url: 'https://www.instagram.com/thalavadychundan/',
    },
    {
      label: 'Official Nehru Trophy — registered boats & track',
      url: 'https://nehrutrophy.nic.in/pages-en-IN/track.php',
    },
    {
      label: 'Champions Boat League — Kerala Tourism',
      url: 'https://www.keralatourism.org/champions-boat-league/',
    },
    ...BOAT_RACE_REFERENCE_LINKS_EN,
    {
      label: 'Onmanorama — 71 boats registered for NTBR 2026',
      url: 'https://www.onmanorama.com/travel/kerala/2026/08/11/nehru-trophy-boat-race-71-boats-register-for-the-iconic-annual-regatta.html',
    },
    {
      label: 'The Hindu — Kuttanad prepares for NTBR 2026',
      url: 'https://www.thehindu.com/news/national/kerala/boat-clubs-in-kerala-shift-into-high-gear-as-kuttanad-readies-for-prestigious-nehru-trophy-boat-race/article71271895.ece',
    },
    {
      label: 'RashtraDeepika — Thalavady Chundan launch story',
      url: 'https://www.rashtradeepika.com/thalavadi-chundan-boat-race/',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'Thalavady Chundan at a glance',
      items: [
        { value: '1 Jan 2023', label: 'Boat launched' },
        { value: '127 ft', label: 'Length — horse-headed prow' },
        { value: '97', label: 'Crew (paddlers + steersmen + singers)' },
        { value: '22 Aug 2026', label: '72nd NTBR — opening CBL leg' },
      ],
    },
    {
      type: 'panel',
      title: 'Aaram Thamburan — the dark horse of Kuttanad',
      paragraphs: [
        'In Kerala’s vallamkali calendar, every village dreams of owning a **chundan vallam** — the long snake boat that carries a hundred hearts on water. **Thalavady Chundan** is one of the newest and most distinctive entries in that tradition. Launched on **1 January 2023**, it is already known across Alappuzha as **Aaram Thamburan** — the “Sixth King” of Thalavady — because it is the village’s sixth snake boat in living memory.',
        'What sets Thalavady apart from classic cobra-hood chundans is its prow: a **teak sculpture of a racehorse**, consecrated at the **Sabarimala Ayyappa temple** before being mounted on the hull. Villagers call it a symbol of speed and grace — a boat built not only to race, but to carry the identity of **Thalavady** and Upper Kuttanad onto Punnamada Lake.',
        'The boat belongs to the **Thalavady Town Boat Club (TTBC)**, a community-owned club with more than **150 shareholders** — local families and NRIs who pooled resources to make a decades-old dream real. On race day, **Kainakary Village Boat Club** rows Thalavady Chundan in major regattas including the **Nehru Trophy Boat Race (NTBR)** and the **Champions Boat League (CBL)**.',
      ],
      chips: ['Thalavady', 'Aaram Thamburan', 'Horse-headed chundan', 'Kuttanad', 'TTBC'],
    },
    {
      type: 'imageGallery',
      title: 'Kuttanad vallamkali in pictures',
      intro:
        'Snake-boat racing scenes from Wikimedia Commons (CC BY-SA). Thalavady Chundan races on the same Punnamada and Pamba waters.',
      images: [
        {
          url: GALLERY_IMAGES.heats,
          alt: 'Nehru Trophy Boat Race — chundan heat on Punnamada',
          caption: 'Nehru Trophy Boat Race, Punnamada Lake — Varghesepunnamada / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'Nehru Trophy boat race, Alleppey',
          caption: 'Vallamkali on Alappuzha backwaters — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'Kerala snake boats racing',
          caption: 'Chundan vallams — Anoopkn / Wikimedia.',
        },
      ],
    },
    {
      type: 'panel',
      title: 'History of Thalavady and the boat club',
      paragraphs: [
        '**Thalavady** is a village in **Upper Kuttanad** panchayat, Alappuzha district — a green, waterlogged landscape where canals are roads and boat races are the social calendar. The name itself carries royal memory: in the days of the **Chempakassery kingdom**, when the king travelled from Ambalapuzha to his summer palace, a ceremonial cracker (**vady**) was fired first at this village. **Thala** (main) + **vady** (cracker) became **Thalavady** — “first cracker.”',
        'For generations Thalavady watched neighbouring villages — Veeyapuram, Kainakary, Neerattupuram — celebrate chundan victories while the community nursed its own ambition. The **Pamba Boat Race** at **Neerattupuram** on **Uthradam** day has been a local fixture for a quarter century. Building a competitive snake boat was the natural next step.',
        'The **Thalavady Town Boat Club** formed around boat-race enthusiasts from Thalavady and nearby hamlets — Veeyapuram south and north, Puthanthuruth, Venkidachira, and beyond. Master carpenter **Sabu Achary** (Sabu Narayanan Achary), one of Kuttanad’s respected **moothashari** boat builders, shaped the 127-foot hull from **anjili** wood using traditional joinery. NRIs and local families funded the build; the horse-head prow was blessed at Sabarimala before launch.',
        'On **New Year’s Day 2023**, Thalavady Chundan touched water for the first time. Within months it proved the sceptics wrong.',
      ],
      chips: ['Chempakassery', 'Neerattupuram', 'Sabu Achary', 'TTBC', 'Upper Kuttanad'],
    },
    {
      type: 'table',
      title: 'Thalavady Chundan — specifications',
      headers: ['Detail', 'Information'],
      rows: [
        ['Length', '127 feet (~39 m)'],
        ['Width', '5 feet'],
        ['Paddlers (varikkar)', '83'],
        ['Steersmen (amarakkar)', '5'],
        ['Choristers / singers', '9'],
        ['Total crew', '97'],
        ['Wood', 'Anjili (wild jack) hull; teak horse sculpture on prow'],
        ['Distinctive feature', 'Horse-headed prow (consecrated at Sabarimala)'],
        ['Launched', '1 January 2023'],
        ['Builder', 'Sabu Achary'],
        ['Owner', 'Thalavady Town Boat Club (TTBC)'],
        ['Racing club', 'Kainakary Village Boat Club'],
        ['Local nickname', 'Aaram Thamburan (Sixth King of Thalavady)'],
        ['Shareholders', '150+ community members and NRIs'],
      ],
    },
    {
      type: 'panel',
      title: 'Victories and race results so far',
      paragraphs: [
        'Thalavady Chundan’s debut season was anything but quiet. In its **inaugural year (2023)**, the boat won the prestigious **Neerattupuram Boat Race** on the Pamba — the Uthradam regatta that Thalavady itself has hosted for decades. Kerala Tourism’s Champions Boat League profile calls it a **“dark horse”** that stunned the circuit on debut.',
        'Since then Thalavady has campaigned across Alappuzha’s monsoon calendar — local heats, CBL legs, and the biggest stage of all: **Punnamada Lake**. At the **71st Nehru Trophy (30 August 2025)**, United Boat Club Kainakary rowed Thalavady Chundan to **fifth place in the heats** — agonisingly close to the four-boat final won by **Veeyapuram Chundan** in 4:21.084 (*Times of India*, 2025).',
        'For 2026, Thalavady is back on the official entry list. **Onmanorama** lists **Thalavady Chundan (Kainakary Village Boat Club)** among **22 chundan boats** registered for the **72nd Nehru Trophy** on **22 August 2026** — with **Padmakumar Puthenparambil** and **Rahul Prakash** named as contacts in earlier NTBR registrations.',
      ],
      list: [
        '**2023 — Neerattupuram Boat Race:** Winner (inaugural season highlight).',
        '**2024–2025 — NTBR & CBL:** Competed on Punnamada; 2025 heat finish 5th (missed final by one position).',
        '**2026 — NTBR #22:** Registered for 72nd Nehru Trophy; CBL season opens from Alappuzha.',
      ],
      callout:
        'Follow live updates on [Thalavady Chundan Facebook](https://www.facebook.com/thalavadychundan/) and [Instagram](https://www.instagram.com/thalavadychundan/) during race weekends.',
    },
    {
      type: 'panel',
      title: 'Upcoming: 72nd Nehru Trophy & Champions Boat League 2026',
      paragraphs: [
        'The **72nd Nehru Trophy Boat Race** is scheduled for **Saturday, 22 August 2026** on **Punnamada Lake, Alappuzha**. For Thalavady Chundan, this is the season’s defining test — 22 snake boats, lakhs of spectators, and a winner’s purse raised to **₹25 lakh**.',
        'NTBR is also the **opening leg of the 2026 Champions Boat League (CBL)** — Kerala Tourism’s professional snake-boat circuit broadcast nationally (Star Sports in recent seasons). After NTBR, CBL races move across Kerala’s backwaters through the Onam season. Clubs earn points across multiple regattas; the overall champion takes the CBL trophy, while the **President’s Trophy** final caps the season.',
        'Kuttanad’s clubs began **residential training camps** in July 2026 — dawn and dusk sessions on veppu and iruttukuthy boats before shifting to full chundan practice once houseboats clear the Punnamada track in early August. Thalavady’s crew will be among them, chasing the final four slots that decide who rows for Nehru’s silver trophy.',
      ],
      orderedList: [
        '**NTBR date:** Saturday, 22 August 2026',
        '**Venue:** Punnamada Lake, Alappuzha (~1.4 km course)',
        '**Thalavady entry:** Chundan #1 in 2026 registration (Kainakary Village Boat Club)',
        '**CBL:** Season opens from NTBR; follow [Kerala Tourism CBL](https://www.keralatourism.org/champions-boat-league/) for race calendar',
        '**Prize money:** ₹25 lakh winner (NTBR snake boat); CBL season champion ₹25 lakh (2025 reference)',
        '**TV / streaming:** Asianet, Manorama, DD Malayalam; Star Sports for CBL',
      ],
    },
    {
      type: 'table',
      title: 'How to track Thalavady Chundan — entries & results',
      intro:
        'Bookmark these official and media sources before race day. Heat timings and lane draws are published closer to 22 August.',
      headers: ['Source', 'What to track', 'Link'],
      rows: [
        [
          'Nehru Trophy official site',
          'Registered boats, heat schedule, live results',
          '[nehrutrophy.nic.in/track](https://nehrutrophy.nic.in/pages-en-IN/track.php)',
        ],
        [
          'NTBR online tickets',
          'Gallery passes for Punnamada race day',
          '[nehrutrophy.nic.in/tickets](https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php)',
        ],
        [
          'Kerala Tourism — Thalavady Chundan',
          'Boat profile, CBL snake-boat gallery',
          '[keralatourism.org/thalavady-chundan](https://www.keralatourism.org/champions-boat-league/snake-boats/thalavady-chundan)',
        ],
        [
          'Champions Boat League',
          'CBL race calendar, points table, season standings',
          '[keralatourism.org/cbl](https://www.keralatourism.org/champions-boat-league/)',
        ],
        [
          'Thalavady Chundan — Facebook',
          'Practice photos, race-day updates, fan community',
          '[facebook.com/thalavadychundan](https://www.facebook.com/thalavadychundan/)',
        ],
        [
          'Thalavady Chundan — Instagram',
          'Reels, crew highlights, victory celebrations',
          '[instagram.com/thalavadychundan](https://www.instagram.com/thalavadychundan/)',
        ],
        [
          'Onmanorama — NTBR 2026',
          'Full 22-chundan registration list',
          '[onmanorama.com NTBR 2026](https://www.onmanorama.com/travel/kerala/2026/08/11/nehru-trophy-boat-race-71-boats-register-for-the-iconic-annual-regatta.html)',
        ],
        [
          'The Hindu — NTBR 2025 result',
          '2025 final: Veeyapuram won; Thalavady 5th in heats',
          '[thehindu.com NTBR 2025](https://www.thehindu.com/news/national/kerala/veeyapuram-chundan-lifts-nehru-trophy-in-photo-finish/article69993332.ece)',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'The Neerattupuram connection',
      paragraphs: [
        'Before Punnamada, Thalavady’s home water is the **Pamba** at **Neerattupuram**. The **Pamba Boat Race** on **Uthradam** — twenty-five years and counting — is where village pride meets temple-season festival. Thalavady Chundan’s **2023 Neerattupuram victory** was more than a sporting result; it was the answer to years of watching other chundans lift trophies while Thalavady waited for its own boat.',
        'Every August the Pamba and Punnamada form a two-stage drama: local regattas build rhythm and crew chemistry; NTBR and CBL decide who enters Kerala’s sporting folklore. For fans of **Aaram Thamburan**, both rivers matter.',
      ],
    },
    {
      type: 'panel',
      title: 'What makes this boat special',
      paragraphs: [
        'Kuttanad has dozens of chundans, but few stories match Thalavady’s speed of ascent. A community-built boat, launched in 2023, already on the NTBR entry sheet beside legends like **Karichal**, **Nadubhagam**, and **Champakulam**. A horse where others wear a cobra hood. A club owned by shareholders who still meet as a **karayogam** — the traditional assembly that decides everything from hull repairs to race strategy.',
        'Whether Thalavady breaks into the 2026 final or claims another Neerattupuram crown, the boat has already done what it was built to do: give Thalavady a name on the water. **Good strokes, good rhythm — and may Aaram Thamburan run fast on 22 August.**',
      ],
      chips: ['Neerattupuram', 'NTBR 2026', 'CBL', 'Punnamada', 'Vallamkali'],
      callout: {
        text: 'Track NTBR heats & results →',
        url: 'https://nehrutrophy.nic.in/pages-en-IN/track.php',
      },
    },
  ],
};
